import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { PhaseConfiguration } from "../../../model/device";

export default function PhaseConfigSelect({ value, onChange, disabled = false }) {
  return (
    <FormControl fullWidth>
      <InputLabel>Phase configuration</InputLabel>
      <Select
        value={value}
        label="Phase configuration"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        <MenuItem key={PhaseConfiguration.UNKNOWN} value={PhaseConfiguration.UNKNOWN}>
          Unknown
        </MenuItem>
        <MenuItem key={PhaseConfiguration.L1L2L3} value={PhaseConfiguration.L1L2L3}>
          L1-L2-L3
        </MenuItem>
        <MenuItem key={PhaseConfiguration.L2L3L1} value={PhaseConfiguration.L2L3L1}>
          L2-L3-L1
        </MenuItem>
        <MenuItem key={PhaseConfiguration.L3L1L2} value={PhaseConfiguration.L3L1L2}>
          L3-L1-L2
        </MenuItem>
      </Select>
    </FormControl>
  );
}
